var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClicknboxOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "#00CC99",
    strokeWidth: 0.612134,
    viewBox: "0 0 38 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c-arm",
    d: "m 33.671861,16.276972 3.77849,-5.505774 -2.291006,-1.5719494 -2.206393,3.2147194 -3.285639,-2.254628 1.106142,4.12915 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "c-foot",
    d: "m 19.062531,25.879759 -9.9710746,8.900172 4.4464536,4.982102 2.072997,-1.849982 -2.595982,-2.909105 8.407518,-7.502993 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "c-body",
    d: "m 35.157088,27.373525 -2.206393,3.21477 -9.744429,-6.685633 8.400451,-2.254686 L 25.94016,0.49887667 4.7909531,6.1655415 6.7851094,13.607077 0.55800213,19.391522 5.1022609,24.284104 7.1383104,22.393288 4.4848478,19.536796 7.5985534,16.644573 10.45752,27.315318 l 9.216633,-2.469456 13.994861,9.603473 3.778588,-5.505676 z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicknboxOuter);
export default __webpack_public_path__ + "static/media/clicknbox_outer.34e0b723.svg";
export { ForwardRef as ReactComponent };